export default "__VITE_ASSET__Blw9vp7N__"